import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import SuggestedQuestions from './SuggestedQuestions';
import { useChatContext } from '../../../providers/ChatProvider';
import { getChatConfig } from '../../../config/chatConfig';

const ChatContent = () => {
  const { 
    messages, 
    isLoading, 
    messagesEndRef,
    scrollToBottomHandler,
    scrollToBottom,
    suggestedQuestions 
  } = useChatContext();

  // Obtener configuración de textos
  const config = getChatConfig();
  const ui = config.ui;

  useEffect(() => {
    if (scrollToBottom) {
      scrollToBottomHandler();
    }
  }, [messages, scrollToBottom, scrollToBottomHandler]);

  const showWelcome = messages.length === 0;
  const showSuggestions = messages.length === 0 && suggestedQuestions.length > 0;

  return (
    <div className="chat-content d-flex flex-column h-100">
      {showWelcome && (
        <div className="chat-empty-state">
          <FontAwesomeIcon icon={faRobot} className="display-4" />
          <h5>{ui.assistant.greeting}</h5>
          <p className="mb-0">
            {ui.assistant.description}
          </p>
          <small className="text-muted mt-2">
            <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
            {ui.assistant.capabilities}
          </small>
        </div>
      )}

      {messages.length > 0 && (
        <ChatMessages />
      )}

      {isLoading && (
        <div className="typing-indicator">
          <div className="typing-animation">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <small className="text-muted">{ui.assistant.status.thinking}</small>
        </div>
      )}

      {showSuggestions && (
        <SuggestedQuestions />
      )}

      <div ref={messagesEndRef} />
      
      <ChatInput />
    </div>
  );
};

export default ChatContent; 